import { useTranslation } from 'next-i18next'
import Comments from 'blocks/Comments'

export function CommentsSection() {
  const { t } = useTranslation('home.page')

  const comments = [
    {
      comment: t('home-comment-1'),
      organization: 'Earthwake',
    },
    {
      comment: t('home-comment-2'),
      organization: '1001 Fontaines',
    },
    {
      comment: t('home-comment-3'),
      organization: 'Trouve Ta Voix',
    },
    {
      comment: t('home-comment-4'),
      organization: 'Café Joyeux',
    },
    {
      comment: t('home-comment-5'),
      organization: 'Beauval Nature',
    },
    {
      comment: t('home-comment-6'),
      organization: "L'ENVOL",
    },
    {
      comment: t('home-comment-7'),
      organization: 'Bibliothèques Sans Frontières',
    },
  ]

  return <Comments comments={comments} />
}
